var path = 'areas/shared/views/script_editor.html';
var html = "<div> <div ng-hide=syntaxSelectionDisabled> <label ng-repeat=\"s in syntaxes\" class=radio-inline><input type=radio ng-model=$parent.syntax value={{s.id}}>{{s.display}}</label> </div> <div class=insert-variable ng-if=!noVariables> <insert-variable-button ng-syntax=syntax project-id=projectId insert=insertVariable local-names=localNames rebind=#{{id}}></insert-variable-button> </div> <a href=\"\" class=fullscreen-button octo-full-screen=#{{id}}Container></a> <div id={{id}}Container> <div id={{id}} class=big-on-full ui-ace=\"{ mode: aceMode, onLoad: editorLoaded }\" ng-model=body></div> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/views/script_editor.html
// module id = 8723603154744498
// module chunks = 1